import { render, staticRenderFns } from "./CategoryRemove.vue?vue&type=template&id=c87c8a40&scoped=true"
import script from "./CategoryRemove.vue?vue&type=script&lang=js"
export * from "./CategoryRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87c8a40",
  null
  
)

export default component.exports